var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticStyle:{"enable-background":"new 0 0 6 3"},attrs:{"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 6 3","xml:space":"preserve"}},[_c('polygon',{staticClass:"arrow",attrs:{"points":"0,3 6,3 3,0 "}})])
}
var staticRenderFns = []

export { render, staticRenderFns }